import React, { Component } from "react";

import Slider, { ArrowButton } from "components/Slider";
import { IntroBlock } from "components/Block";
import Grid, { Container } from "components/Grid";
import Tabs, { Tab } from "components/Tabs";

import Event from "./Event";

import { Inner } from "./styles";

class Events extends Component {
  state = {
    slide: 0
  };

  handleTab = slide => {
    this.tabSlider && this.tabSlider.slickGoTo(slide);
  };

  render() {
    const { slide } = this.state;
    const { content } = this.props;

    const tabSettings = {
      dots: false,
      arrows: false,
      infinite: false,
      draggable: false,
      swipe: false,
      adaptiveHeight: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: slide,
      beforeChange: (current, next) => this.setState({ slide: next })
    };

    const eventSettings = {
      dots: false,
      speed: 300,
      infinite: false,
      slidesToShow: 5,
      draggable: false,
      nextArrow: <ArrowButton type="next" shade="dark" />,
      prevArrow: <ArrowButton type="previous" shade="dark" />,
      responsive: [
        {
          breakpoint: 1800,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 700,
          settings: {
            centerMode: true,
            centerPadding: "20px",
            slidesToShow: 1
          }
        }
      ]
    };

    return (
      <Container display="block" bg="white" py={["50px", "80px"]}>
        <Grid>
          <IntroBlock px="20px" content={content} />
          <Tabs m={["40px auto 10px", "60px auto 30px"]}>
            {content.sections.map((section, index) => (
              <Tab
                key={index}
                active={slide === index}
                onClick={() => this.handleTab(index)}
              >
                {section.title}
              </Tab>
            ))}
          </Tabs>
        </Grid>
        <Slider innerRef={ref => (this.tabSlider = ref)} {...tabSettings}>
          {content.sections.map((section, index) => (
            <Inner key={index}>
              <Slider {...eventSettings}>
                {content.sections[slide].events.map((event, index) => (
                  <Event key={index} content={event} />
                ))}
              </Slider>
            </Inner>
          ))}
        </Slider>
      </Container>
    );
  }
}

export default Events;
